class IFormFile {

    //Variables
    el;
    elTable;
    elType;
    elMaximum;
    elProgress;
    elRequired;

    //Methods
    constructor(target) {
        let thisObj = this;

        //Assign elements
        this.el = $(target);
        this.elTable = document.getElementById(target.id + "Table");
        this.elType = document.getElementById(target.id).getAttribute("filetype");
        this.elMaximum = document.getElementById(target.id).getAttribute("maximum");
        this.elProgress = document.getElementById(target.id + "Progress");
        this.elRequired = $(target).attr('required') != null;
        this.elInvoiceIndex = document.getElementById(target.id).getAttribute("invoiceIndex");
        this.elInvoiceId = document.getElementById(target.id).getAttribute("invoiceId");
        //Assign events
        $(target).change(function (e) {
            var count = thisObj.elTable.getElementsByTagName('tbody')[0].querySelectorAll('.table-item').length;
            if (count < thisObj.elMaximum) {
                var file = document.getElementById(e.target.id).files[0];
                var data = new FormData();
                data.append('image', file);
                data.append('type', thisObj.elType);
                data.append('invoiceIndex', thisObj.elInvoiceIndex);
                data.append('invoiceId', thisObj.elInvoiceId);
                thisObj.Action_uploadimage(data);
            }
        }).click(function () {
            $(this).val("");
            $(this.elProgress).css("width", "0%");
        });
        for (let i = 0; i < $('.customfile-action').length; i++) {
            let id = $('.customfile-action')[i].id;
            $('#' + id).on('click', function (event) {
                thisObj.Action_deleteimage(i + 1, id, thisObj.elType, thisObj.elInvoiceIndex);
            });
        }
        thisObj.HTML_updatebutton();
    }

    Action_uploadimage(data) {
        let thisObj = this;
        let el = this.el;
        let elProgress = this.elProgress;
        el.prop('disabled', true);
        var ProgramYear = document.getElementById("ProgramYear").value;
        data.append('programYear', ProgramYear);
        //Append AntiForgeryToken to payload
        var token = $('input[name="__RequestVerificationToken"]').val();
        data.append('__RequestVerificationToken', token);

        //HTTP request to controller
        $.ajax({
            xhr: function () {
                var xhr = new XMLHttpRequest();
                $(elProgress).addClass("progress-bar-animated");
                xhr.upload.addEventListener("progress", function (evt) {
                    if (evt.lengthComputable) {
                        var percentComplete = (evt.loaded / evt.total * 100) / 1.5;
                        $(elProgress).css("width", percentComplete + "%");
                    }
                }, false);
                xhr.addEventListener("progress", function (evt) {
                    if (evt.lengthComputable) {
                        var percentComplete = (evt.loaded / evt.total * 100);
                        $(elProgress).css("width", percentComplete + "%");
                    }
                }, false);
                return xhr;
            },
            type: 'POST',
            url: GLOBALROOTURL + '/ClientRequest/SaveFileUpload',
            data: data,
            processData: false,
            contentType: false,
            success: function (response) {
                //Add image to Table
                data.append('uniqueid', '');
                data.append('rowname', '');
                let i = 1;
                response.forEach(function (r) {
                    data.set('uniqueid', r);
                    if (response.length > 1) {
                        data.set('rowname', data.get('image').name + ' #' + i);
                    }
                    else {
                        data.set('rowname', data.get('image').name);
                    }
                    thisObj.HTML_addimagetotable(data);
                    i++;
                });
                $(elProgress).css("width", "100%");
                window.setTimeout(function () {
                    $(elProgress).css("width", "0%");
                    $(elProgress).removeClass("progress-bar-animated");
                    el.prop('disabled', false);
                    thisObj.HTML_updatebutton();
                }, 500);

            },
            error: function (xhr, ajaxOptions, thrownError) {
                $(elProgress).css("width", "100%");
                window.setTimeout(function () {
                    $(elProgress).css("width", "0%");
                    $(elProgress).removeClass("progress-bar-animated");
                    el.prop('disabled', false);
                    alert(xhr.responseText);
                }, 500);
            }
        });
    }

    Action_deleteimage(tableRow, id, type, invoiceIndex) {
        let thisObj = this;

        //Fetch the body of the table
        let table = this.elTable.getElementsByTagName('tbody')[0];

        //Initially delete the row
        table.deleteRow((tableRow - 1));

        //If there are no more rows insert default row
        if (table.rows.length === 0) {
            var newRow = table.insertRow(table.rows.length);
            newRow.outerHTML = '<tr class="table-row"><td scope="row"></td><td></td><td><button type="button" class="customfile-action-none" disabled ><i class="fa fa-trash-alt"></i></button></td></tr >';
        } else {
            //Update existing rows with correct ids and attributes
            thisObj.HTML_updaterows();
        }

        //Instantiate payload to send to controller
        var data = new FormData();
        data.append('id', id);
        data.append('type', type);
        data.append('invoiceIndex', invoiceIndex);
        //Append AntiForgeryToken to payload
        var token = $('input[name="__RequestVerificationToken"]').val();
        data.append('__RequestVerificationToken', token);

        //Send a request to remove that image from image uploads
        $.ajax({
            type: 'POST',
            url: GLOBALROOTURL + '/ClientRequest/DeleteFileUpload',
            contentType: "application/json; charset=utf-8",
            data: data,
            processData: false,
            contentType: false,
            success: function () {
                //Image was removed
                thisObj.HTML_updatebutton();
            },
            error: function (xhr, ajaxOptions, thrownError) {
                //Image was not found
                alert("FAILED",thrownError);
            }
        });
    }

    HTML_addimagetotable(data) {
        let thisObj = this;

        //Fetch the body of the table
        var table = this.elTable.getElementsByTagName('tbody')[0];

        //Delete table row if its the starting row
        if (table.rows[0].cells[1].innerHTML.trim() === '') {
            table.deleteRow(0);
        }

        table = this.elTable.getElementsByTagName('tbody')[0];
        var newRow = table.insertRow(table.rows.length);
        newRow.outerHTML = '<tr class="table-row table-item"><td scope="row">' + table.rows.length + '</td><td class="customfile-filename">' + data.get('rowname') + '</td><td><button type="button" class="customfile-action" id="' + data.get('uniqueid') + '"><i class="fa fa-trash-alt"></i></button></td></tr >';
        let tableRow = table.rows.length;
        let id = data.get('uniqueid');
        $('#' + id).on('click', function (event) {
            thisObj.Action_deleteimage(tableRow, id, data.get('type'), thisObj.elInvoiceIndex);
        });
    }

    HTML_updaterows() {
        let thisObj = this;

        //Fetch the body of the table
        var table = this.elTable.getElementsByTagName('tbody')[0];

        //Loops through existing rows and changes Id and onlick function attributes
        for (let i = 0; i < table.rows.length; i++) {

            //Replace table Id with correct number
            table.rows[i].cells[0].innerHTML = i + 1;

            //Grab the image Id that was an attribute in the delete method.
            let id = table.rows[i].cells[2].firstChild.getAttribute('id').toString();

            //Assign the fetched image Id to the inner HTML
            table.rows[i].cells[2].innerHTML = '<button type="button" class="customfile-action" id="' + id + '"><i class="fa fa-trash-alt"></i></button>';
            $('#' + id).off('click');
            $('#' + id).on('click', function (event) {
                thisObj.Action_deleteimage(i + 1, id, thisObj.elType, thisObj.elInvoiceIndex);
            });
        }
    }

    HTML_updatebutton() {
        let thisObj = this;
        var count = thisObj.elTable.getElementsByTagName('tbody')[0].querySelectorAll('.table-item').length;

        if (count >= thisObj.elMaximum) {
            thisObj.el.prop('disabled', true);
        }
        else {
            thisObj.el.prop('disabled', false);
        }

        //Workaround for client-side issue: file upload input is required but data is retrieved from the session and cannot set the value of the input (due to security reasons)
        if (this.elRequired) {
            if (count > 0) {
                thisObj.el.prop('required', false);
            }
            else {
                thisObj.el.prop('required', true);
            }
        }
    }
}
//Instantiate on page load if matching HTML is found
const IFormFileMap = new Map();
$(function () {
    let elementsByClass = document.getElementsByClassName("IFormFile");
    for (let i = 0; i < elementsByClass.length; i++) {
        const currentElement = elementsByClass.item(i);
        if (!IFormFileMap.has(currentElement)) {
            IFormFileMap.set(currentElement, new IFormFile(currentElement));
        }
    };
});